<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Nyckelpunkter
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Sammanfattningskort i tekniksidans sidebar. Visar de viktigaste lärdomarna
      med teal-bockikoner.
    </p>

    <PreviewFull label="Exempel">
      <div
        class="w-full rounded-[20px] p-6"
        style="background: #f8fffe; border: 1px solid rgba(20, 184, 166, 0.15)"
      >
        <div class="flex items-center gap-2 mb-4">
          <CheckCircle2 :size="18" color="#14b8a6" />
          <h3 class="font-[Poppins] font-bold text-[15px] text-[#191c1e] m-0">
            Nyckelpunkter
          </h3>
        </div>
        <ul class="m-0 p-0 list-none flex flex-col gap-3">
          <li
            v-for="point in points"
            :key="point"
            class="flex items-start gap-2.5"
          >
            <span
              class="w-1.5 h-1.5 rounded-full bg-teal-500 flex-shrink-0 mt-[7px]"
            />
            <span
              class="font-[Plus_Jakarta_Sans] text-[14px] text-[#3c4947] leading-[1.6]"
              >{{ point }}</span
            >
          </li>
        </ul>
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { CheckCircle2 } from "lucide-vue-next";
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div class="w-full rounded-[20px] p-6"
  style="background: #f8fffe; border: 1px solid rgba(20,184,166,0.15)">
  <div class="flex items-center gap-2 mb-4">
    <CheckCircle2 :size="18" color="#14b8a6" />
    <h3 class="font-[Poppins] font-bold text-[15px] text-[#191c1e] m-0">Nyckelpunkter</h3>
  </div>
  <ul class="m-0 p-0 list-none flex flex-col gap-3">
    <li v-for="point in points" :key="point" class="flex items-start gap-2.5">
      <span class="w-1.5 h-1.5 rounded-full bg-teal-500 flex-shrink-0 mt-[7px]" />
      <span class="font-[Plus_Jakarta_Sans] text-[14px] text-[#3c4947] leading-[1.6]">{{ point }}</span>
    </li>
  </ul>
</div>`;
const cssCode = `/* Kort-container */
background: #f8fffe;
border: 1px solid rgba(20,184,166,0.15);
border-radius: 20px;
padding: 24px;   /* p-6 */

/* Punkt-markör */
width: 6px;      /* w-1.5 */
height: 6px;     /* h-1.5 */
border-radius: 9999px;
background: #14b8a6;  /* bg-teal-500 */

/* Lista-font */
font-family: 'Plus Jakarta Sans', sans-serif;
font-size: 14px;
color: #3c4947;
line-height: 1.6;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const points = [
  "Autolys låter glutenproteiner absorbera vatten innan knådning börjar",
  "Minst 20–30 minuter ger märkbar skillnad i degens elasticitet",
  "Salt och jäst bör tillsättas efter autolysperioden",
  "Tekniken är särskilt effektiv för deg med hög hydrering",
];
</script>
